import React, { useState, useEffect } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { LayoutProvider } from './context/LayoutContext';
import { useAuth } from './context/AuthContext';
import LoginPage from './components/LoginPage';
import NotificationPage from './components/Notifications/NotificationPage';
import WindowsPage from './components/windows/WindowsPage';
import ApplePage from './components/ApplePage';
import ChromePage from './components/ChromePage';
import ProtectedRoute from './components/ProtectedRoute';
import NavigationBar from './components/NavigationBar';
import './App.css';
import SupportModal from './components/modals/SupportModal';
import Support from './components/SupportPage';
import AdminPage from './components/AdminPage';
import AdminPageEditor from './components/AdminPageEditor';
import InstallRouter from './components/android/InstallRouter';
import AndroidDesktopPage from './components/android/AndroidDesktopPage';

function App() {
  const [modalOpen, setModalOpen] = useState(false);
  const location = useLocation();
  const { token } = useAuth();
  const isLoginPage =
    location.pathname === '/esafe/login' || location.pathname === '/login';

  const isMobile = (() => {
    if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;

    const ua = navigator.userAgent || '';
    const uaMobile = /Android|iPhone|iPad|iPod/i.test(ua);
    const coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    const narrow = window.innerWidth < 1024;

    return uaMobile || (coarse && narrow);
  })();

  const isAndroidPage =
    location.pathname === '/android' ||
    location.pathname.startsWith('/android/') ||
    location.pathname === '/esafe/android' ||
    location.pathname.startsWith('/esafe/android/');

  return (
    <LayoutProvider>
      {!isLoginPage && token && <NavigationBar />}

      <div className={isLoginPage ? '' : `main-content ${isAndroidPage ? 'android' : 'desktop'}`}>
        <div className="app">
          <Routes>
            <Route path="/" element={<Navigate to="/notification" replace />} />

            <Route path="/login" element={<LoginPage />} />
            <Route path="/admin/editor" element={<AdminPageEditor />} />

            <Route
              path="/notification"
              element={
                <ProtectedRoute>
                  <NotificationPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/notifications/:documentName"
              element={
                <ProtectedRoute>
                  <NotificationPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/windows"
              element={
                <ProtectedRoute>
                  <WindowsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/windows/:documentName"
              element={
                <ProtectedRoute>
                  <WindowsPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/mac"
              element={
                <ProtectedRoute>
                  <ApplePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mac/:documentName"
              element={
                <ProtectedRoute>
                  <ApplePage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/chrome"
              element={
                <ProtectedRoute>
                  <ChromePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/chrome/:documentName"
              element={
                <ProtectedRoute>
                  <ChromePage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/androiddesktop"
              element={
                <ProtectedRoute>
                  <Navigate to="/androiddesktop/android-desktop" replace />
                </ProtectedRoute>
              }
            />
            <Route
              path="/androiddesktop/:documentName"
              element={
                <ProtectedRoute>
                  <AndroidDesktopPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/supports"
              element={
                <ProtectedRoute>
                  <Support />
                </ProtectedRoute>
              }
            />
            <Route
              path="/support/:documentName"
              element={
                <ProtectedRoute>
                  <Support />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/android/*"
              element={
                <ProtectedRoute>
                  <InstallRouter />
                </ProtectedRoute>
              }
            />

            <Route
              path="/esafe/android/*"
              element={<Navigate to="/android" replace />}
            />
          </Routes>

          <SupportModal
            isOpen={modalOpen}
            onClose={() => setModalOpen(false)}
          />
        </div>
      </div>
    </LayoutProvider>
  );
}

export default App;
